import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../../../../shared/environment.service';

@Injectable({
  providedIn: 'root',
})
export class HolidaysService {
  constructor(public http: HttpClient, public env: EnvironmentService) {}
  //fetch all holidays
  fetchAllHolidays(locId: any) {
    let param = `?locationId=${locId}`;
    let url = `holidays${param}`;
    return this.env.get(url);
  }

  fetchAllHolidayByYear(params: any,locId: any) {
    let queryParam = `?locationId=${locId}`;
    let url = `holidays/year/${params}${queryParam}`;
    return this.env.get(url);
  }

  fetchSingleHolidayById(params: any,locId: any) {
    let queryParam = `?locationId=${locId}`;
    let url = `holidays/${params}${queryParam}`;
    return this.env.get(url);
  }

  saveHoliday(params: any) {
    let url = `holidays`;
    return this.env.post(url, params);
  }

  updateHoliday(editDataId: any, params: any) {
    let url = `holidays/${editDataId}`;
    return this.env.put(url, params);
  }

  importHoliday(params: any) {
    let url = `holidays/import`;
    return this.env.post(url, params);
  }

  updateHolidayStatus(editDataId: any, params: any) {
    let url = `holidays/${editDataId}`;
    return this.env.patch(url, params);
  }

  deleteHolidays(params: any) { 
    const url = `holidays`;
    return this.env.deleteWithPayload(url, params);
  }
}
